import Typed from "typed.js";

const PromoInfo = () => {
	const block = document.querySelectorAll(".promo-info");
	if (!block) {
		return;
	}

	block.forEach((el) => {
		const title = el.querySelector(".promo-info__title");
		const words = title.getAttribute("data-words");

		if (words) {
			const typed = new Typed(title.querySelector("span"), {
				strings: words.split(","),
				startDelay: 300,
				typeSpeed: 100,
				backSpeed: 50,
				backDelay: 2000,
				loop: true,
				showCursor: false
			});
		}
	});
};

export default PromoInfo;
